(() => {
  window.SwymCallbacks = window.SwymCallbacks || [];

  const HEADER = '.header-actions__action.wishlist-icon';
  const BTN = '.plp-wishlist';

  const setHeader = (filled) => {
    document.querySelectorAll(HEADER).forEach(el => {
      el.classList.toggle('is-filled', filled);
      el.classList.toggle('added', filled);
    });
  };

  const setBtn = (btn, added) => {
    btn.classList.toggle('swym-added', added);
    btn.classList.toggle('swym-removed', !added);
  };

  const fetchWishlist = (swat) =>
    new Promise(resolve => {
      try {
        swat.fetch(items => resolve(items || []));
      } catch {
        resolve([]);
      }
    });

  const sync = async (swat) => {
    const items = await fetchWishlist(swat);
    const ids = new Set(items.map(i => String(i.epi)));

    document.querySelectorAll(BTN).forEach(btn => {
      setBtn(btn, ids.has(String(btn.dataset.variantId)));
    });

    setHeader(items.length > 0);
  };

  const toggle = async (swat, btn) => {
    const items = await fetchWishlist(swat);

    const existing = items.find(i =>
      String(i.epi) === String(btn.dataset.variantId)
    );

    if (existing) {
      setBtn(btn, false);
      swat.removeFromWishList(existing, () => sync(swat));
      return;
    }

    setBtn(btn, true);
    setHeader(true);

    swat.addToWishList({
      epi: btn.dataset.variantId,
      empi: btn.dataset.productId,
      du: btn.dataset.productUrl,
      dt: btn.dataset.title,
      pr: btn.dataset.price
    }, () => sync(swat));
  };

  const init = (swat) => {
    document.addEventListener('click', e => {
      const btn = e.target.closest(BTN);
      if (!btn) return;

      e.preventDefault();
      toggle(swat, btn);
    });

    // initial sync
    sync(swat);

    // only watch for new wishlist buttons
    let t;
    new MutationObserver((muts) => {
      for (const m of muts) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches?.(BTN) || node.querySelector?.(BTN)) {
            clearTimeout(t);
            t = setTimeout(() => sync(swat), 100);
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('sw:addedtowishlist', () => sync(swat));
    document.addEventListener('sw:removedfromwishlist', () => sync(swat));
  };

  if (window._swat) init(window._swat);
  else window.SwymCallbacks.push(init);

})();